import { makeStyles } from '@material-ui/core';
export default makeStyles((theme) => ({
  loader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  errorMessage: {
    fontSize: 15,
    letterSpacing: 0.35,
    color: theme.palette.error.main,
  },
  invstBulkContainer: {
    height: 'calc(100vh - 136px)',
    overflow: 'auto',
  },
  invstBulkContent: {
    display: 'grid',
    gap: '45px',
    gridTemplateColumns: 'auto auto',
    marginTop: 35,
    '@media (max-width: 525px)': {
      gridTemplateColumns: 'none',
    },
  },
  invstBulkList: {
    boxShadow: theme.shadows[3],
    borderRadius: 11,
    background: theme.palette.primary.contrastText,
    maxWidth: '495px',
    position: 'relative',
  },
  borderColor: {
    background: theme.palette.grey[800],
    height: 15,
    borderTopLeftRadius: 11,
    borderTopRightRadius: 11,
  },
  invstNameBox: {
    background: '#FFC29F24',
    padding: '25px 30px 15px',
    display: 'flex',
    '@media (max-width: 767px)': {
      padding: '25px 20px 15px',
    },
  },
  invstNameLeft: {
    alignSelf: 'center',
    width: 'calc(100% - 150px)',
    '@media (max-width: 767px)': {
      width: 'calc(100% - 110px)',
    },
  },
  invstNameRight: {
    width: 150,
    textAlign: 'right',
    '@media (max-width: 767px)': {
      width: 110,
    },
  },
  nameTxt: {
    fontSize: 22,
    letterSpacing: 0.35,
    color: '#081F32',
    '@media (max-width: 767px)': {
      fontSize: 16,
    },
  },
  amountTxt: {
    fontSize: 17,
    fontWeight: 700,
    letterSpacing: 0.35,
    color: theme.palette.warning.contrastText,
  },
  completeTxt: {
    fontSize: 12,
    color: theme.palette.common.black,
  },
  invstBody: {
    padding: '15px 30px 25px',
  },
  progressInvst: {
    marginBottom: 10,
    '&.MuiLinearProgress-colorPrimary': {
      background: '#c4c4c4',
      borderRadius: '100px',
      height: 8,
    },
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: theme.palette.secondary.main,
      borderRadius: '100px',
    },
  },
  progressTxt: {
    fontSize: 16,
    color: '#6E798C',
    maxWidth: 420,
    marginBottom: 25,
  },
  minInvstTxt: {
    fontSize: 14,
    letterSpacing: 0.35,
    marginBottom: 35,
  },
  minSubInvst: {
    background: theme.palette.grey.A200,
    padding: '3px 30px',
    borderRadius: 4,
    color: theme.palette.common.white,
    fontSize: 14,
    letterSpacing: 0.35,
    marginLeft: 30,
  },
  knowBtn: {
    background: theme.palette.secondary.main,
    color: theme.palette.primary.contrastText,
    borderRadius: 8,
    fontSize: 16,
    fontWeight: 800,
    cursor: 'pointer',
    textTransform: 'capitalize',
    height: 57,
    width: '100%',
    '&:hover': {
      background: theme.palette.secondary.main,
      color: theme.palette.primary.contrastText,
    },
    '&.Mui-disabled': {
      background: theme.palette.primary.main,
    },
  },
  newDeals: {
    position: 'absolute',
    width: 140,
    height: 40,
    borderRadius: 5,
    backgroundColor: theme.palette.grey.A200,
    textAlign: 'center',
    color: theme.palette.common.white,
    top: '-13px',
    left: 0,
    fontFamily: theme.typography.fontFamily,
    fontSize: 20,
    fontWeight: 900,
    lineHeight: '27px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  ///Notification box style
  notificationBox: {
    background: '#AED3FF',
    boxShadow: theme.shadows[3],
    padding: 15,
    borderRadius: 11,
    display: 'flex',
  },
  notificationTxt: {
    width: 'calc(100% - 15px)',
    paddingRight: 25,
    fontSize: 14,
    lineHeight: '20px',
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    color: theme.palette.common.black,
  },
  closeIcon: {
    width: 15,
  },
  // Dialog box styles
  dialogStyles: {
    '& .MuiDialog-paperScrollPaper': {
      maxHeight: 'calc(100% - 200px)',
    },
    '& .MuiDialog-paperWidthSm': {
      maxWidth: 450,
    },
    '& .MuiTypography-h6': {
      lineHeight: 0.6,
    },
    '& .makeStyles-titleText-105': {
      padding: '15px 15px 15px',
    },
  },
  welcomeBoxBody: {
    maxWidth: 400,
    margin: 'auto',
    textAlign: 'center',
    paddingTop: 10,
  },
  welcomeImgImage: {
    height: 190,
    marginBottom: 6,
  },
  newDealBox: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 15,
  },
  newDealsText: {
    width: 120,
    height: 35,
    borderRadius: 5,
    backgroundColor: theme.palette.grey.A200,
    fontWeight: 900,
    lineHeight: '27px',
    fontSize: 16,
    color: theme.palette.common.white,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  newDealsAdded: {
    fontFamily: theme.typography.fontFamily,
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '28px',
    letterSpacing: 0.35,
  },
  seeMoreBtnBox: {
    width: '100%',
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.primary.contrastText,
    borderRadius: 10,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 800,
    fontSize: 15,
    cursor: 'pointer',
    height: 58,
    textTransform: 'none',
    marginTop: 25,
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.primary.contrastText,
    },
  },
}));
